import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GalleryRoutingModule } from './gallery-routing.module';
import { GalleryPageComponent } from './components/gallery-page/gallery-page.component';
import { GalleryListComponent } from './components/gallery-list/gallery-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { GalleryAddComponent } from './components/gallery-add/gallery-add.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [GalleryPageComponent, GalleryListComponent,GalleryAddComponent],
  imports: [
    CommonModule,
    GalleryRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule,
    NgxMatSelectSearchModule
  ],
  entryComponents: [GalleryAddComponent]
})
export class GalleryModule { }
